








import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import SwChartChartJsMixin from './sw-chart-chart-js.mixin.vue';
import { DoughnutroundedOptions } from './chartjs-plugin-doughnutrounded';

@Component
export default class SwDonutConcentric extends mixins(SwChartChartJsMixin) {
  @Prop({ default () { return { }; } })
  chartData: Chart.ChartDataSets[];

  @Prop({ default: -1 })
  value: number; // selected index.

  @Prop()
  labels: string[];

  @Prop({ default() {
    return ['#ffcc00', '#99cc00', '#9999ff', '#E90076', '#787DB6', '#47AFE8',
      '#BBDB70', '#FF4229', '#FCCEC6', '#7DD7E0'];
  } })
  colorPalette: string[];

  selected = -1;
  datasetIndex = -1;

  get chartOptions(): Chart.ChartOptions {
    return {
      cutoutPercentage: 25,
      legend: {
        display: false,
      },
      events: ['mousemove'],
      onHover: (evt) => {
        // to be debounced..
        if (this.chartInstance) {
          const evtPoint = (this.chartInstance.getElementAtEvent(evt) as any);
          if (evtPoint && evtPoint.length > 0) {
            // get dataseteIndex and dataindex
            this.datasetIndex = evtPoint[0]._datasetIndex;
            this.selected = evtPoint[0]._index;
            // this.$emit('change', evtPoint[0]._index);
          } else {
            this.selected = -1;
            this.datasetIndex = -1;
          }
        }
      },
      plugins: {
        doughnutrounded: {
          applyToDatasets: this.chartData.map((dataset: Chart.ChartDataSets, index: number) => {
            return {
              index,
              dataset,
              dataIndices: [0],
              label: this.labels[this.selected],
            };
          }),
        } as DoughnutroundedOptions,
      },
      tooltips: {
        enabled: false,
      },
    };
  }

  get dataSetOption() {
    return {
      borderColor: '#000000',
      hoverBorderColor: '#ff791a',
    };
  }

  get centerLabels(): string[] {
    if (this.selected > -1) {
      const data = this.chartData[this.datasetIndex]!.data! as number[];
      const sum = data.reduce((p: number, c: number) => { return p + c; });
      return [
        `${this.labels[this.selected]}`,
        `${Math.round(100 * data[this.selected] / sum)}%`,
      ];
    }
    return ['', ''];
  }

  @Watch('labels')
  @Watch('theme')
  @Watch('chartData', { deep: true })
  private onDataChanged() {
    if (this.chartInstance) {
      this.chartInstance.data.labels = this.labels;
      if (this.chartInstance.data.datasets) {
        this.chartInstance.data.datasets = this.chartData.map((dataset: Chart.ChartDataSets, index: number) => {
          return Object.assign({}, dataset, {
            borderColor: '#000000',
            backgroundColor: [this.colorPalette[index], '#333333'],
          },
    );
        });
      }
      this.chartInstance.update();
    }
  }

  @Watch('chartOptions', { deep: true })
  private onConfigChanged() {
    if (this.chartInstance) {
      (this.chartInstance as any).options = this.chartOptions;
      this.chartInstance.update(0);
    }
  }

  mounted() {
    this.initChart({
      type: 'doughnut',
      data: {
        labels: this.labels,
        datasets: this.chartData.map((dataset: Chart.ChartDataSets, index: number) => {
          return Object.assign({}, dataset, {
            borderColor: '#000000',
            backgroundColor: [this.colorPalette[index], '#333333'],
          },
          );
        }),
        // chartData should contain only data series. but mixined with const color.
      },
      options: this.chartOptions,
    });
  }
}
